import { StringSanitization } from 'lib/fields';

export const DEFAULT_MAX_CHAR_LENGTH = 1024;
export const DEFAULT_REDACTION_POLICY = 'none';
export const DEFAULT_WRITE_POLICY = 'none';
export const DEFAULT_SANITIZE: Array<StringSanitization> = [];
export const DELETE_DISABLED_TEXT = "This field is referenced in the flow and can't be deleted";
export const LABEL_VALIDATION_MESSAGE = 'Field must have a label';
export const MAX_LENGTH_VALIDATION_MESSAGE = `Max length must be less than ${DEFAULT_MAX_CHAR_LENGTH}`;

export const PANEL_HEADER_HEIGHT = 76;
export const PANEL_FOOTER_HEIGHT = 64;
